﻿export const MEASUREMENT_FIELD_ROUTE_ID = "routeId";
export const MEASUREMENT_FIELD_TIMESTAMP = "timestamp";
export const MEASUREMENT_FIELD_DISTANCE = "distance";

export const MEASUREMENT_FIELD_OPTIMAL_DURATION = "optimalDuration";
export const MEASUREMENT_FIELD_OPTIMAL_SPEED = "optimalVelocity";

export const MEASUREMENT_FIELD_TYPICAL_DURATION = "typicalDuration";
export const MEASUREMENT_FIELD_TYPICAL_SPEED = "typicalVelocity";

export const MEASUREMENT_FIELD_CURRENT_DURATION = "currentDuration";
export const MEASUREMENT_FIELD_CURRENT_SPEED = "currentVelocity";

export const MEASUREMENT_FIELD_DELAY_FACTOR = "jamFactor";
export const MEASUREMENT_FIELD_DELAY_DURATION = "jamDuration";
export const MEASUREMENT_FIELD_SPEED_DIFFERENCE = "speedDifference";

export const MEASUREMENT_FIELD_START_GATE_NAME = "startGateName";
export const MEASUREMENT_FIELD_END_GATE_NAME = "endGateName";
export const MEASUREMENT_FIELD_ROUTE_NAME = "routeName";

export const MEASUREMENT_DURATION_FIELDS = [
    MEASUREMENT_FIELD_OPTIMAL_DURATION,
    MEASUREMENT_FIELD_TYPICAL_DURATION,
    MEASUREMENT_FIELD_CURRENT_DURATION,
    MEASUREMENT_FIELD_DELAY_DURATION
]

export const SELECTABLE_MEASUREMENT_METRIC_FIELDS = [
    MEASUREMENT_FIELD_OPTIMAL_DURATION,
    MEASUREMENT_FIELD_OPTIMAL_SPEED,
    MEASUREMENT_FIELD_TYPICAL_DURATION,
    MEASUREMENT_FIELD_TYPICAL_SPEED,
    MEASUREMENT_FIELD_CURRENT_DURATION,
    MEASUREMENT_FIELD_CURRENT_SPEED,
    MEASUREMENT_FIELD_DELAY_FACTOR,
    MEASUREMENT_FIELD_DELAY_DURATION,
    MEASUREMENT_FIELD_SPEED_DIFFERENCE,
]

const BASE_MEASUREMENT_TABLE_FIELDS = [
    MEASUREMENT_FIELD_TIMESTAMP,
    ...SELECTABLE_MEASUREMENT_METRIC_FIELDS
];

export const SECTION_MEASUREMENT_TABLE_FIELDS = [
    MEASUREMENT_FIELD_START_GATE_NAME,
    MEASUREMENT_FIELD_END_GATE_NAME,
    ...BASE_MEASUREMENT_TABLE_FIELDS
]

export const ROUTE_MEASUREMENT_TABLE_FIELDS = [
    MEASUREMENT_FIELD_ROUTE_NAME,
    ...BASE_MEASUREMENT_TABLE_FIELDS
]

export const SECTION_MEASUREMENT_TABLE_PAGE_TITLE = "Sectie";
export const ROUTE_MEASUREMENT_TABLE_PAGE_TITLE = "Route";